console.log( 'this is the view script' );
